export const messages = {
  dobWithAgeDeceasedFormat: {
    id: 'dobWithAgeDeceasedFormat',
    defaultMessage: '-def-{0} (D)',
  },
  dobWithAgeYearsFormat: {
    id: 'dobWithAgeYearsFormat',
    defaultMessage: '-def-{0} ({1} Y)',
  },
  dobWithAgeMonthsFormat: {
    id: 'dobWithAgeMonthsFormat',
    defaultMessage: '-def-{0} ({1} M)',
  },
};